import { render } from "./Trail.vue?vue&type=template&id=51a4f4ef&scoped=true"
import script from "./Trail.vue?vue&type=script&lang=js"
export * from "./Trail.vue?vue&type=script&lang=js"

import "./Trail.vue?vue&type=style&index=0&id=51a4f4ef&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a4f4ef"]])

export default __exports__